import React, {useEffect, useState} from 'react';
import GoogleCategorySelector from "../../../../services/categories/GoogleCategorySelector";
import GoogleAttributesSelector from "../../../../services/categories/GoogleAttributesSelector";
import UploadGalleryStore from "../../../../components/uploadgallery/uploadGalleryStore";
import reviewBuilderUploadsApi from "../../../../components/uploadgallery/reviewBuilderGalleryApi";
import {Modal, ModalBody, ModalFooter, ModalHeader, UncontrolledTooltip} from "reactstrap";
import UploadGallery from "../../../../components/uploadgallery/UploadGallery";
import client from '../../../../services/session/apiClient';
const _ = require('lodash');

function BulkLocationEditorGoogle({   setFormIsInvalid,
                                      singleLocationMode,
                                      selectedLocations,
                                      locationPatch,
                                      updateImages,
                                      updatePinFlag,
                                      mergeIntoLocationPatch,
                                      categoriesStore,
                                      mergeGoogleCategoriesIntoLocationPatch,
                                      googleAttributesStore,
                                      updateAttributes
}) {
    const [coverPhotoSelectorOpen, setCoverPhotoSelectorOpen] = useState(false);
    const [profilePhotoSelectorOpen, setProfilePhotoSelectorOpen] = useState(false);
    const [generalPhotoSelectorOpen, setGeneralPhotoSelectorOpen] = useState(false);
    const [manuallyPlaced, setManuallyPlaced] = useState(locationPatch.googleListingManagementSpecs.doNotMovePin);
    const [uploadGalleryStore, setUploadGalleryStore] = useState(new UploadGalleryStore(reviewBuilderUploadsApi));

    const addImage = (imageUrl, type) => {
        if (type == "COVER" || type == "PROFILE") {
            locationPatch.googleListingManagementSpecs.photos.filter(image => image.sourceUrl !== imageUrl && image.locationAssociationCategory !== type);
        }
        updateImages(locationPatch.googleListingManagementSpecs.photos.concat([{
            sourceUrl: imageUrl,
            locationAssociationCategory: type
        }]))
    };

    const setCoverPhoto = (imageUrl) => {
        setCoverPhotoSelectorOpen(false); //to do
        addImage(imageUrl, "COVER")
    }

    const setProfilePhoto = (imageUrl) => {
        setProfilePhotoSelectorOpen(false); //to do
        addImage(imageUrl, "PROFILE")
    }

    const hasPhotoSet = (locationPatch, type) => {
        const answer = (!!locationPatch.googleListingManagementSpecs.photos
            && locationPatch.googleListingManagementSpecs.photos.find(x => x.locationAssociationCategory == type) != undefined);
        return answer;
    };

    const getPhotoUrl = (locationPatch, type) => {
        const googleImage = locationPatch.googleListingManagementSpecs.photos.find(x => x.locationAssociationCategory == type)
        return googleImage.sourceUrl || googleImage.googleUrl
    }

    function unsetPhotoUrl(type) {
        updateImages(locationPatch.googleListingManagementSpecs.photos.filter(image => image.locationAssociationCategory !== type))
    }

    function unsetCoverPhoto() {
        unsetPhotoUrl("COVER")
    }

    function unsetProfilePhoto() {
        unsetPhotoUrl("PROFILE")
    }

    const addGeneralPhoto = (imageUrl) => {
        setGeneralPhotoSelectorOpen(false);
        addImage(imageUrl, "ADDITIONAL")
    };

    const removeGeneralPhoto = (imageUrl) => {
        updateImages(locationPatch.googleListingManagementSpecs.photos.filter(gPhoto => !(gPhoto.locationAssociationCategory == "ADDITIONAL" && (gPhoto.sourceUrl == imageUrl || gPhoto.googleUrl == imageUrl))))
    };

    const toggleManuallyPlaced = () => {
        const newManuallyPlaced = !manuallyPlaced
        setManuallyPlaced(newManuallyPlaced);
        locationPatch.googleListingManagementSpecs.doNotMovePin = newManuallyPlaced
        updatePinFlag(newManuallyPlaced)
    };

    const setTrackingNumber = (e) => {
        const trackingNumber = e.target.value;
        mergeIntoLocationPatch({
            "listingManagementSpecs": {
                "providerTrackingNumbers": {
                    "GOOGLEMAP": trackingNumber
                }
            }
        })
    };

    const setTrackingUrl = (e) => {
        const trackingUrl = e.target.value;
        mergeIntoLocationPatch({
            "listingManagementSpecs": {
                "providerTrackingWebsiteUrls": {
                    "GOOGLEMAP": trackingUrl
                }
            }
        })
    };

    const hasCoverPhoto = hasPhotoSet(locationPatch, "COVER")
    const hasProfilePhoto = hasPhotoSet(locationPatch, "PROFILE")
    // General photos are all types that aren't cover or profile photos. This includes types such as MENU and FOOD_AND_DRINK
    const generalPhotoUrls = locationPatch.googleListingManagementSpecs.photos.filter(image => image.locationAssociationCategory != "COVER" && image.locationAssociationCategory != "PROFILE").map(x => x.sourceUrl || x.googleUrl);
    
    function handleAdditionalCategoryUpdate(selection) {
        mergeGoogleCategoriesIntoLocationPatch(selection)
    }

    function handleAttributesUpdate(selection){
        updateAttributes(selection)
    }


    return <div className="card-spacer-top card-spacer-bottom">
        <h5 className="content-spacer-top"> Additional Categories </h5>
        <div className="row card-spacer-top">
            <div className="col-12">
                <GoogleCategorySelector
                    multi={true}
                    selected={locationPatch.googleListingManagementSpecs.googleCategories || []}
                    googleCategoriesStore={categoriesStore}
                    onSelect={handleAdditionalCategoryUpdate}
                />
            </div>
        </div>

        <h5 className="content-spacer-top"> Attributes </h5>
        {singleLocationMode && <div>
            Your business category and region determine the attributes available for your location. Only available attributes for this location on Google are selectable. Additionally, subjective attributes may appear on your listing, but these rely on the opinions of Google customers who've visited your business and are not configurable.
        </div>
        }
        {!singleLocationMode && <div>
            Some attributes are only available in certain industries. Selected attributes will be sent to Google for all locations, but only attributes available for each location will be accepted and published to each listing by Google.
        </div>
        }
        <div className="row card-spacer-top">
            <div className="col-12">
                <GoogleAttributesSelector
                    multi = {true}
                    selected = {locationPatch.googleListingManagementSpecs.attributes || []}
                    locationIds = {selectedLocations}
                    onSelect = {handleAttributesUpdate}
                    isInvalid={setFormIsInvalid}
                    googleAttributesStore={googleAttributesStore}
                />
            </div>

        </div>

        <h5 className="content-spacer-top">Call Tracking Number</h5>
        <div className="row card-spacer-top">
            <div className="col-12">
                <input
                    disabled={!singleLocationMode}
                    type="text"
                    id="googleTrackingPhone"
                    placeholder="Tracking Phone Number"
                    maxLength={155}
                    value={locationPatch.listingManagementSpecs.providerTrackingNumbers.GOOGLEMAP || ''}
                    onChange={setTrackingNumber}
                    className={"form-control text-input" + (!singleLocationMode ? " cursor-not-allowed" : "")}
                />
                {!singleLocationMode && <UncontrolledTooltip target="googleTrackingPhone">
                    Call Tracking Number can only be edited for single locations.
                </UncontrolledTooltip>}
            </div>
        </div>

        <h5 className="content-spacer-top">UTM/Tracking Website URL</h5>
        <div className="row card-spacer-top">
            <div className="col-12">
                <input
                    type="text"
                    id="googleTrackingUrl"
                    placeholder="Tracking Url"
                    maxLength={155}
                    value={locationPatch.listingManagementSpecs.providerTrackingWebsiteUrls.GOOGLEMAP || ''}
                    onChange={setTrackingUrl}
                    className="form-control text-input"
                />
            </div>
        </div>

        <h5 className="content-spacer-top"> Google Map Pin </h5>
        <div className="row card-spacer-top">
        <p>
            Google automatically places a location's pin based on its address. If you have manually moved this pin away from Google's default, selecting this option will omit address info from being passed to Google that would reset the pin to its original spot.
        </p>
            <div className="custom-control custom-checkbox control-spacer-left inline-block">
                <input type="checkbox" id={"dontMove"} className="custom-control-input"
                       checked={manuallyPlaced === true} onChange={toggleManuallyPlaced}/>
                <label className="custom-control-label" htmlFor={"dontMove"}>Manually Placed - Do Not Move Pin</label>
            </div>
        </div>

        <h5 className="card-spacer-top">Profile Photo</h5>
        <div className="row card-spacer-top">
            {hasProfilePhoto && <div className="col-4 col-sm-4">
                <div className="img-gallery-item">
                    <div className="text-center overflow-hidden">
                        <img src={getPhotoUrl(locationPatch, "PROFILE")} style={{"height": "100px"}}/>
                    </div>
                    <div className="text-center" style={{"marginTop": "3px"}}>
                        <a onClick={unsetProfilePhoto} href="javascript:void(0)"
                           style={{textDecoration: 'underline'}}>Remove</a>
                    </div>
                </div>
            </div>}
            {!hasProfilePhoto && <div className="col-4 col-sm-4">
                <div className="img-gallery-item">
                    <div className="text-center overflow-hidden">
                        <div style={{"height": "91px", "opacity": "0"}}/>
                        {/* Spacer to match height of uploaded images */}
                        <button type="button" className="btn btn-secondary"
                                onClick={() => setProfilePhotoSelectorOpen(true)}>
                            <i className="far fa-plus"/>
                        </button>
                    </div>
                </div>
            </div>}
        </div>
        {profilePhotoSelectorOpen &&
        <Modal isOpen={true} toggle={() => setProfilePhotoSelectorOpen(false)} className="modal-lg">
            <ModalHeader toggle={() => setProfilePhotoSelectorOpen(false)}>Select or Upload a Profile
                Image</ModalHeader>
            <ModalBody>
                <UploadGallery minImageWidthPixels={250} minImageHeightPixels={250} maxImageWidthPixels={5000} maxImageHeightPixels={5000} uploadGalleryStore={uploadGalleryStore} imageSelectedCallback={image => setProfilePhoto(image.url)}/>
            </ModalBody>
            <ModalFooter>
                <button type="button" className="btn btn-secondary"
                        onClick={() => setProfilePhotoSelectorOpen(false)}>Cancel
                </button>
                {" "}
            </ModalFooter>
        </Modal>}

        <h5 className="card-spacer-top">Cover Photo</h5>
        <div className="row card-spacer-top">
            {hasCoverPhoto && <div className="col-4 col-sm-4">
                <div className="img-gallery-item">
                    <div className="text-center overflow-hidden">
                        <img src={getPhotoUrl(locationPatch, "COVER")} style={{"height": "100px"}}/>
                    </div>
                    <div className="text-center" style={{"marginTop": "3px"}}>
                        <a onClick={unsetCoverPhoto} href="javascript:void(0)"
                           style={{textDecoration: 'underline'}}>Remove</a>
                    </div>
                </div>
            </div>}
            {!hasCoverPhoto && <div className="col-4 col-sm-4">
                <div className="img-gallery-item">
                    <div className="text-center overflow-hidden">
                        <div style={{"height": "91px", "opacity": "0"}}/>
                        {/* Spacer to match height of uploaded images */}
                        <button type="button" className="btn btn-secondary"
                                onClick={() => setCoverPhotoSelectorOpen(true)}>
                            <i className="far fa-plus"/>
                        </button>
                    </div>
                </div>
            </div>}
        </div>
        {coverPhotoSelectorOpen &&
        <Modal isOpen={true} toggle={() => setCoverPhotoSelectorOpen(false)} className="modal-lg">
            <ModalHeader toggle={() => setCoverPhotoSelectorOpen(false)}>Select or Upload a Cover Image</ModalHeader>
            <ModalBody>
                <UploadGallery imageAspectRatio={1.7778} aspectRatioPrettyReadable={"16:9"}  minImageWidthPixels={720} minImageHeightPixels={720} maxImageWidthPixels={2120} maxImageHeightPixels={1192} uploadGalleryStore={uploadGalleryStore} imageSelectedCallback={image => setCoverPhoto(image.url)}/>
            </ModalBody>
            <ModalFooter>
                <button type="button" className="btn btn-secondary"
                        onClick={() => setCoverPhotoSelectorOpen(false)}>Cancel
                </button>
                {" "}
            </ModalFooter>
        </Modal>}

        <h5 className="content-spacer-top">Add General Images</h5>
        <div className="row card-spacer-top">
            {generalPhotoUrls.map(photoUrl => {
                return <div className="col-4 col-sm-4">
                    <div className="img-gallery-item">
                        <div className="text-center overflow-hidden">
                            <img src={photoUrl} style={{"height": "100px"}}/>
                        </div>
                        <div className="text-center" style={{"marginTop": "3px"}}>
                            <a onClick={() => removeGeneralPhoto(photoUrl)} href="javascript:void(0)"
                               style={{textDecoration: 'underline'}}>Remove</a>
                        </div>
                    </div>
                </div>
            })}
            {<div className="col-4 col-sm-4">
                <div className="img-gallery-item">
                    <div className="text-center overflow-hidden">
                        <div style={{"height": "91px", "opacity": "0"}}/>
                        {/* Spacer to match height of uploaded images */}
                        <button type="button" className="btn btn-secondary"
                                onClick={() => setGeneralPhotoSelectorOpen(true)}>
                            <i className="far fa-plus"/>
                        </button>
                    </div>
                </div>
            </div>}
        </div>
        {generalPhotoSelectorOpen &&
        <Modal isOpen={true} toggle={() => setGeneralPhotoSelectorOpen(false)} className="modal-lg">
            <ModalHeader toggle={() => setGeneralPhotoSelectorOpen(false)}>Select or Upload a General
                Image</ModalHeader>
            <ModalBody>
                <UploadGallery maxFileSizeBytes={10000000} minImageWidthPixels={720} minImageHeightPixels={720} maxImageWidthPixels={5000} maxImageHeightPixels={5000} uploadGalleryStore={uploadGalleryStore} imageSelectedCallback={image => addGeneralPhoto(image.url)}/>
            </ModalBody>
            <ModalFooter>
                <button type="button" className="btn btn-secondary"
                        onClick={() => setGeneralPhotoSelectorOpen(false)}>Cancel
                </button>
                {" "}
            </ModalFooter>
        </Modal>}

    </div>
}

export default BulkLocationEditorGoogle;
